/**
 * Domain errors for timelog registration.
 * Design: correcto-registro-de-timelogs-locales-y-remotos (D2, D5)
 *
 * Pure domain objects — ZERO external dependencies.
 */

/**
 * Thrown when the identified employee has no resolved structure (idStructure <= 0).
 * The use case SHALL NOT enqueue a timelog when this error is raised.
 */
export class MissingEmployeeStructureError extends Error {
  override readonly name = 'MissingEmployeeStructureError';

  constructor(message = 'El empleado no tiene una estructura asignada') {
    super(message);
  }
}

/**
 * Thrown when the employee idEntity is missing or zero.
 * Prevents admin session entity from leaking into timelog records.
 */
export class InvalidEmployeeEntityError extends Error {
  override readonly name = 'InvalidEmployeeEntityError';

  constructor(message = 'El identificador de entidad del empleado es inválido') {
    super(message);
  }
}
